__turbopack_context__.v({
  "fadeInFromLeft": "shops-list-module-scss-module__wrtK3a__fadeInFromLeft",
  "root": "shops-list-module-scss-module__wrtK3a__root",
});
